'use client';

import ActionButton from '@/components/form/ActionButton/ActionButton';
import RoundArrowIcon from '@/components/ui/RoundArrowIcon/RoundArrowIcon';
import styles from './DesignCtaButton.module.scss';

type DesignCtaButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  text: string;
  size?: 'fullWidthMedium' | 'fullWidthLarge';
};

/**
 * デザイン関連のCTAボタン
 * UserDesignDetailModalとGfDesignShareContainerで共通使用
 */
function DesignCtaButton({ onClick, disabled = false, text, size = 'fullWidthMedium' }: DesignCtaButtonProps) {
  return (
    <ActionButton onClick={onClick} size={size} bgColor='black' color='white' disabled={disabled}>
      <div className={styles.ctaButtonWrapper}>
        <span className={styles.ctaButtonText}>{text}</span>
        <span className={styles.ctaButtonIcon}>
          <RoundArrowIcon direction='right' color='white' isBold sizePc='medium' />
        </span>
      </div>
    </ActionButton>
  );
}

export default DesignCtaButton;
